module.exports = __webpack_public_path__ + "static/img/turbohaler_red.4c9346f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trackers/turbohaler_red.jpg
// module id = EBVy
// module chunks = 0